module.exports = __webpack_public_path__ + "static/media/django.bcf22073.svg";